import { useSelector } from 'react-redux'

import { selectRole } from '../../../../../../../routing/fetchingfunction/user/user.reducer'

import { TUTOR_ROLE } from '../../../../../../../constants'

const WalletItem = ({ label, value }) => {
  const role = useSelector(selectRole)

  const isTutor = role === TUTOR_ROLE

  return (
    <div
      className={`inline-flex flex-col items-center jsutify-center ${isTutor ? 'py-[5px]' : 'py-[13.3px]'} !border border-primary-450 rounded bg-primary-500`}
    >
      <span className="text-primary-75 font-medium !mb-1">{label}</span>
      <span className="text-primary-100 text-sm font-bold">{value}</span>
    </div>
  )
}

export default WalletItem
